import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Upload, Download } from "lucide-react";
import { API } from "@/App";

const ImportModal = ({ 
  isOpen, 
  onClose, 
  isDragging, 
  setIsDragging, 
  importLoading, 
  onImport 
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="import-modal">
        <DialogHeader>
          <DialogTitle>Import Subscriptions</DialogTitle>
        </DialogHeader>
        
        {/* Download Template Button */}
        <div className="flex justify-center mb-4">
          <Button
            variant="outline"
            onClick={() => {
              window.open(`${API}/subscriptions/template`, '_blank');
            }}
            className="border-indigo-200 text-indigo-600 hover:bg-indigo-50"
            data-testid="download-subscriptions-template-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            Download Import Template
          </Button>
        </div>
        
        <div 
          className={`border-2 border-dashed rounded-lg p-8 text-center ${isDragging ? "border-indigo-500 bg-indigo-50" : "border-slate-300"}`}
          onDragOver={e => { e.preventDefault(); setIsDragging(true); }}
          onDragLeave={e => { e.preventDefault(); setIsDragging(false); }}
          onDrop={e => { e.preventDefault(); setIsDragging(false); onImport(e.dataTransfer.files[0]); }}
        >
          {importLoading ? (
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto" />
          ) : (
            <>
              <Upload className="w-12 h-12 text-slate-400 mx-auto mb-4" />
              <p className="text-slate-600 mb-2">Drag and drop your Excel or CSV file</p>
              <p className="text-xs text-slate-400 mb-2">CSV must match the export format (Business Name, Likeliness, Sign Up Date, Initial Price, Initial Paid, Latest Renewal Date, Latest Renewal Price, Latest Renewal Paid, Notes)</p>
              <label className="cursor-pointer">
                <span className="bg-indigo-600 text-white px-4 py-2 rounded-md">Browse Files</span>
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={e => onImport(e.target.files[0])} 
                  className="hidden"
                  data-testid="import-file-input"
                />
              </label>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportModal;
